import appShellProxyRequestTransformer from "./appShellProxyRequestTransformer";
import goldenGateRequestTransformer from "./goldenGateRequestTransformer";
const getEnvironmentRequestTransformer = serviceName => {
  let REACT_APP_GOLDEN_GATE = "false";
  try {
    REACT_APP_GOLDEN_GATE = process.env.REACT_APP_GOLDEN_GATE || "false";
  } catch (ex) {}
  let REACT_APP_API_PROXY = "";
  try {
    REACT_APP_API_PROXY =
      process.env.REACT_APP_API_PROXY || REACT_APP_API_PROXY;
  } catch (ex) {}
  return REACT_APP_GOLDEN_GATE === "true" || !REACT_APP_API_PROXY
    ? goldenGateRequestTransformer(serviceName)
    : appShellProxyRequestTransformer(serviceName);
};
export default getEnvironmentRequestTransformer;
